import { API_MAP, agent } from 'helpers';

class UserService {
  static listMyAffiliates() {
    return agent.get(`${API_MAP.listMyAffiliates}`);
  }

  static listMyCoupons() {
    return agent.get(`${API_MAP.listMyCoupons}`);
  }

  static user() {
    return agent.get(`${API_MAP.user}`, null, { cache: false });
  }
}

export default UserService;
